exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".W25zG4FF_vAtembkjKlZ0{width:380px}._1voO_VeYVWP0LevvXpk4a{font-size:12px;font-weight:400}html[dir=ltr] .khK4vtSaGQXG3V-TBgMmt .ms-ContextualMenu-link{padding-left:40px}html[dir=rtl] .khK4vtSaGQXG3V-TBgMmt .ms-ContextualMenu-link{padding-right:40px}", ""]);
// Exports
exports.locals = {
	"fixWidthContextMenu": "W25zG4FF_vAtembkjKlZ0",
	"smallFontContextMenu": "_1voO_VeYVWP0LevvXpk4a",
	"conditionalPadding": "khK4vtSaGQXG3V-TBgMmt"
};